var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 0.5C10.1266 0.5 7.80655 1.20379 5.83316 2.52236C3.85977 3.84094 2.3217 5.71509 1.41345 7.9078C0.505199 10.1005 0.267559 12.5133 0.730582 14.8411C1.1936 17.1689 2.33649 19.3071 4.01472 20.9853C5.69295 22.6635 7.83115 23.8064 10.1589 24.2694C12.4867 24.7324 14.8995 24.4948 17.0922 23.5866C19.2849 22.6783 21.1591 21.1402 22.4776 19.1668C23.7962 17.1935 24.5 14.8734 24.5 12.5C24.4966 9.31846 23.2312 6.26821 20.9815 4.01852C18.7318 1.76883 15.6815 0.503441 12.5 0.5V0.5ZM16.5 13.5H13.5V16.5C13.5 16.7652 13.3946 17.0196 13.2071 17.2071C13.0196 17.3946 12.7652 17.5 12.5 17.5C12.2348 17.5 11.9804 17.3946 11.7929 17.2071C11.6054 17.0196 11.5 16.7652 11.5 16.5V13.5H8.50001C8.23479 13.5 7.98043 13.3946 7.7929 13.2071C7.60536 13.0196 7.50001 12.7652 7.50001 12.5C7.50001 12.2348 7.60536 11.9804 7.7929 11.7929C7.98043 11.6054 8.23479 11.5 8.50001 11.5H11.5V8.5C11.5 8.23478 11.6054 7.98043 11.7929 7.79289C11.9804 7.60536 12.2348 7.5 12.5 7.5C12.7652 7.5 13.0196 7.60536 13.2071 7.79289C13.3946 7.98043 13.5 8.23478 13.5 8.5V11.5H16.5C16.7652 11.5 17.0196 11.6054 17.2071 11.7929C17.3946 11.9804 17.5 12.2348 17.5 12.5C17.5 12.7652 17.3946 13.0196 17.2071 13.2071C17.0196 13.3946 16.7652 13.5 16.5 13.5Z",
    fill: "#1E1E1E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdd);
export default __webpack_public_path__ + "static/media/add.8ea86c510ce2f77d4aa86300a1eb87e9.svg";
export { ForwardRef as ReactComponent };